
(function ($, d, ns) {

    ns.setupMenus = function () {
        $('#js-mp-menu-trigger-mid').on('click', function (e) {
            e.preventDefault();
            $('#js-mp-menu-trigger').trigger('click');
        });
        $('#js-mp-menu-trigger').on('click', function (e) {
            $('.show-dropdown').toggleClass('show-dropdown');
            $('.js-show-dropdown.active').removeClass('active');
            $('.js-up-down.icon-up').removeClass('icon-up');
        });
        if (Modernizr.csstransforms3d) {
            //Check to ensure that the menu could in theory exist...
            if ($('#js-mp-menu-trigger').length > 0) {
                new mlPushMenu(document.getElementById('mp-menu'), document.getElementById('js-mp-menu-trigger'), document.getElementById('js-mp-menu-trigger-mid'));
            }
        } else {
            $('#js-mp-menu-trigger').on('click', function (e) {
                e.preventDefault();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $('.mp-menu').addClass('active');
            });

            $('.mp-level li a').not('.mp-back').on('click', function (e) {
                var $parent = $(this).parent();
                if ($parent.find('.mp-level').length) {
                    // there's another level so disable link and show
                    e.preventDefault();
                    $(this).parent().addClass('active');
                }
            });

            $('.mp-level li a.mp-back').on('click', function (e) {
                e.preventDefault();
                $(this).closest('.active').removeClass('active');
            });

            $('.mp-menu > .mp-level > div.mp-back').on('click', function (e) {
                e.preventDefault();
                $('.mp-menu').removeClass('active');
            });
        };
    }

    $(d).ready(function () {
        ns.setupMenus();
    });

})(jQuery, document, Crafted.Utilities);